// ui/settings-options.js: pure settings-panel option data (B2-2/B2-3).
//
// Lives in a .js file (not the .jsx) so unit tests can import it under
// Node's native ESM loader without a JSX transform step. SettingsPanel.jsx
// renders these; the CRT effect itself ships in crt-shader.js + crt.css.

/**
 * CRT effect choices. Every tier is selectable (B2-2): the effect
 * shipped, so no option is disabled and none carries a coming-soon tag.
 */
export const CRT_OPTIONS = [
  { value: 'off', label: 'Off', disabled: false, tag: '' },
  { value: 'subtle', label: 'Subtle', disabled: false, tag: '' },
  { value: 'full', label: 'Full', disabled: false, tag: '' },
];

/**
 * Whether the panel shows the local Stick the Dealer switch. Online,
 * stick the dealer is a room setting owned by the host (RoomSettings);
 * the local switch only drives the dev hot-seat view, so only GameView
 * passes true (B2-3).
 *
 * @param {boolean|undefined} showStickTheDealer
 * @returns {boolean}
 */
export function resolveShowStickTheDealer(showStickTheDealer) {
  return showStickTheDealer === true;
}
